import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { Button } from "@/shared/components/ui/Button";
import { Logo } from "@/shared/components/ui/Logo";
import { FormField } from "@/shared/components/form/FormField";
import { PasswordFormField } from "@/shared/components/form/PasswordFormField";
import { useLogin } from "@/shared/lib/auth";

export function Login() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    login.mutate(
      { email, password },
      { onSuccess: () => navigate("/app") },
    );
  }

  return (
    <Section
      spacing="lg"
      className="min-h-screen flex flex-col items-center justify-center gap-8"
    >
      <Logo to="/" />
      <Container size="sm">
        <div className="glass-surface-strong rounded-2xl p-8 flex flex-col gap-6">
          <div className="flex flex-col gap-2 text-center">
            <h1 className="type-heading-md text-text">Welcome back</h1>
            <p className="type-body-base text-text-muted">
              Sign in to manage your guest lists.
            </p>
          </div>
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <FormField
              label="Email"
              type="email"
              name="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <PasswordFormField
              label="Password"
              name="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <p className="type-body-sm text-text-muted -mt-2 text-right">
              <Link
                to="/auth/recover"
                className="text-brand underline-offset-4 hover:underline"
              >
                Forgot your password?
              </Link>
            </p>
            {login.error ? (
              <p className="type-body-sm text-danger-strong mx-4">
                {login.error.message}
              </p>
            ) : null}
            <Button type="submit" disabled={login.isPending}>
              {login.isPending ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="type-body-sm text-text-muted text-center">
            New here?{" "}
            <Link to="/auth/signup" className="text-brand underline-offset-4 hover:underline">
              Create an account
            </Link>
          </p>
        </div>
      </Container>
    </Section>
  );
}
